export * from './window-type-4.component';